<template>
<div class="content">
  <!--购物车组件-->
  <!-- 购物车为空 S -->
  <div v-if="cartList.length === 0" class="empty">
    <div class="empty-tips">
      空空如也~
      <div class="go-goods" @click="goHome">去逛逛</div>
    </div>
  </div>
  <div style="margin-top: 2.66667vw;" class="cardStyle" v-else>
    <div class="mch-list-box">
      <div class="mch-item" v-for="(item,index) in cartList" :key="index">
        <div class="checkboxGroup" >
          <div class="mch-header left-justifying">
<!--            <img v-if="!item.isShop" class="cart-checkbox" @click="checkGroup(index)" :src="item.checked_all==1? selectActive:selectDefault" alt="" />-->
            <img v-if="item.isShop" class="cart-checkbox" :src="selectActive" @click="chooseShopSelectDefault(index)" />
            <img v-if="!item.isShop" class="cart-checkbox" :src="selectDefault" @click="chooseShopSelect(index)" />
            <img style="display: inline-block;height: auto;width: 3.2vw;margin-right: 1.33333vw;" src="../assets/shop_icon.png" alt="" />  {{item.shop_name}}
          </div>
          <div class="goods-list">
            <div class="goods-item left-justifying" v-for="(cartGoods, gIndex) in item.goods" :key="gIndex">
              <img class="cart-checkbox" v-if="cartGoods.goods.on_sale==0||cartGoods.goods.number==0 || cartGoods.goods.number<cartGoods.number" src="../assets/no_select.png" alt="" />
              <img class="cart-checkbox" v-else @click="chooseGoodsSelect(index, gIndex)" :src="cartGoods.selected==true? selectActive:selectDefault" alt="" />
<!--              <van-swipe-cell>-->
                <div class="card-box left-justifying" style="align-items: self-start;">
                  <img :src="cartGoods.goods.image" @click="goGoodsDes(cartGoods.goods.id)" alt="" />
                  <div class="car-content">
                    <div class="car-title" :style="{'color': (cartGoods.goods.on_sale==0 || cartGoods.goods.number<cartGoods.number?'#999':'')}" @click="goGoodsDes(cartGoods.goods.id)">{{cartGoods.goods.name}}</div>
                    <div class="specification-box" v-if="cartGoods.goods.on_sale==0">
                      <span class="specification-item" style="color: #ff0008">已下架</span>
                    </div>
                    <div class="specification-box" v-if="cartGoods.goods.number<cartGoods.number">
                      <span class="specification-item" style="color: #ff0008">库存不足</span>
                    </div>
                    <div class="justify-align good-price-box">
                      <div class="good-price" :style="{'color': (cartGoods.goods.on_sale==0|| cartGoods.goods.number<cartGoods.number?'#999':'#F23926')}">￥{{cartGoods.goods.price}}</div>
                      <div class="flex-row left-justifying">
<!--                        <template v-if="cartGoods.goods.on_sale==1 && cartGoods.number <= cartGoods.goods.number">-->
                        <div class="cart-less" @click="cartLess(cartGoods,item.id)" v-if="cartGoods.goods.on_sale==1 && cartGoods.number <= cartGoods.goods.number">-</div>
<!--                          <img @click="cartLess(cartGoods,item.id)" class="image1" v-if="cartGoods.goods.on_sale==1 && cartGoods.number <= cartGoods.goods.number" src="../assets/less.png" />-->
<!--                        <img class="image1" v-else src="../assets/less_no.png" />-->
                        <div class="cart-less-no" v-else>-</div>
<!--                        </template>-->
                        <div class="row-data" :style="{'color':(cartGoods.goods.on_sale==1 && cartGoods.number <= cartGoods.goods.number)?'':'#999'}">{{cartGoods.number}}</div>

<!--                        <img class="image1" @click="cartAddNo" src="../assets/add_no.png" v-if="cartGoods.goods.number<= cartGoods.number" />-->
                          <div class="cart-add-no" @click="cartAddNo" v-if="cartGoods.goods.number<= cartGoods.number">+</div>
                          <div class="cart-add-number" @click="cartAdd(cartGoods)" v-else>+</div>
<!--                          <img @click="cartAdd(cartGoods)" class="image1" src="../assets/add.png" v-else />-->


                      </div>
<!--                      <van-stepper v-if="cartGoods.goods.on_sale==1 && cartGoods.goods.number !=0" @change="stepperChange(cartGoods,item.id)" disable-input min="0" :max="cartGoods.goods.number" v-model="cartGoods.number" integer/>-->
                    </div>

                  </div>
                </div>
<!--                <template #right>-->
<!--                  <van-button square text="删除" type="danger"-->
<!--                              class="delete-button" @click="deleteButton(item)"/>-->
<!--                </template>-->
<!--              </van-swipe-cell>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>

    </div>

  </div>
  <div class="null-box2"></div>
  <!-- 购物车结算 S -->

<!--  多商户的-->
  <div class="goods-settle-accounts justify-align" :style="{'bottom':tabbarHeight+'px'}" v-if="cartList.length > 0">
    <div class="left left-justifying">
<!--      <img v-if="isCheckAll" class="select" :src="selectActive" @click="chooseCheckAll" />-->
<!--      <img v-if="!isCheckAll" class="select" :src="selectDefault" @click="chooseCheckAll" />-->
<!--      全选-->
      <div class="goods-price-total" style="padding-left:5.33333vw;padding-top: 2.66667vw" @click="clearClick">
       <span style="color: #9C9C9C;">删除</span>
      </div>
    </div>
    <div class="right left-justifying">
      <template v-if="!adminShow">
        <div class="goods-price-total">
          <span>合计: </span>
          <span style="color: #F23926;">¥ <b style="font-size: 8vw;">{{total}}</b></span>
        </div>
        <div class="goods-count-btn" @click="submitOrder">
          结算 <span v-if="goodsLength != ''">({{goodsLength}})</span>
        </div>
      </template>
    </div>
  </div>
  <!-- 购物车结算 E -->
</div>
</template>

<script>
// import Tips from "../components/Tips";
import { Dialog } from 'vant';
import {getCartList, upDataCart, cartClear} from "@/api/cart";
export default {
  name: 'Cart',
  data(){
    return {
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: 'null',
      isSelf: true,// 自营的 false 多商户
      isLogin: '',
      selectActive: require('@/assets/select_active.png'),
      selectDefault: require('@/assets/select.png'),
      mchChecked: false,
      //控制步进器显示
      isShowStepper: false,
      result: [],
      cartTotal: {},
      cartList: [],
      goodsLoseEfficacy: [],
      total: 0, // 选中商品总价
      hasLogin: null,
      // 控制滑动效果
      adminShow: false, // 编辑选择默认false
      isStop: false, // 店铺下所有商品全选/取消全选默认false
      isSelection: false, // 规格选择默认false
      isCheckAll: false, // 购物车全选/反选默认false
      tabbarHeight:100,
      shopActive: -1,
      selectGoodsCurr: '', // 当前选中的商品对象
      shopId: '',
      goodsLength:''
    }
  },
  computed: {
    //控制全选框状态
    isAllCheck: {
      get() {
        //当所有复选框被选中,数组的长度等于商品的长度
        return (this.result.length === this.cartList.length) && (this.result.length > 0)
      }, set() {
      }
    },
    //商品总价计算
    // goodsTotalPrice: {
    //   get() {
    //     let totalPrice = 0;
    //     //获取购物车中所有的商品信息,根据选中状态进行商品总价计算
    //     this.cartList.forEach(item => {
    //       if (item.isChecked === '1') {
    //         totalPrice += item.price * item.number;
    //       }
    //     })
    //     return totalPrice * 100;
    //   }, set() {
    //   }
    // }
  },
  mounted() {
    var div = document.getElementById('tabbar');
    this.tabbarHeight = div.offsetHeight
    // console.log(div.offsetHeight); // 224
  },
  created() {
    this.getList()

  },
  methods: {
    goGoodsDes(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
    goHome(){
      this.$router.push('/');
    },
    clearClick(){ // 清空购物车
      Dialog.confirm({
        title: '提示',
        message: '是否要清空购物车？',
      })
        .then(() => {
          // on confirm
          this.submitCartClear()
        })
        .catch(() => {
          // on cancel
        });
    },
    submitCartClear(){
      cartClear().then(res => {
        if (res.code == 200){
          this.$toast('删除成功')
          setTimeout(() => {
            //通知父组件关闭
            console.log('调列表数据')
            this.getList()
          }, 1000);
        } else {
          this.$toast(res.message)
        }
      })
    },
    getList(){
      var that = this
      let cartbox = []
      getCartList().then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)

          res.data.map(function(value,index, item){
            // console.log(value)
            cartbox[index] = {
              shop_name: value[0].shop.name,
              isShop: false,
              id: value[0].shop_id,
              goods: value
            }
          })
          // console.log(cartbox.length)
          that.cartList = cartbox
          // console.log(that.cartList)
          // 加载状态结束
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    submitOrder(){
      // console.log('结算',this.cartList)
      var cartList = this.cartList
      var arr = []
      for (let i = 0; i < cartList.length; i++) {
        for (let j = 0; j < cartList[i].goods.length; j++) {
          if (cartList[i].goods[j].selected && cartList[i].goods[j].goods.on_sale==1 && cartList[i].goods[j].number<= cartList[i].goods[j].goods.number) {
            // cartList[i].goods[j].goods.number 库存
            // cartList[i].goods[j].number 加入购物车数量
            // console.log('cartList[i].goods[j].goods.number',cartList[i].goods[j].goods.number)
           arr.push(cartList[i].goods[j].id)
          }
        }
      }
      // console.log('obj',arr)
      if (arr != ''){
        const shopid = this.shopId
        // console.log('selectGoodsCurr',this.selectGoodsCurr)
        // console.log('shopid',this.shopId)
        var goodsid = JSON.stringify(arr)
        this.$router.push({ path:'/cartPay',query: { shopid: shopid,cartids: goodsid} })
      } else {
        this.$toast('请选择商品')
      }

    },
    // 编辑按钮切换
    chooseSwitchover() {
      this.adminShow = !this.adminShow
    },
    // 计算总价
    totalPrice() {
      let cartList = this.cartList;
      let total = 0;
      let goods_num = 0;
      let arr = []
      for (let i = 0; i < cartList.length; i++) {
        for (let j = 0; j < cartList[i].goods.length; j++) {
          // cartList[i].goods[j].goods.number 库存
          // cartList[i].goods[j].number 加入购物车数量
          if (cartList[i].goods[j].selected && cartList[i].goods[j].goods.on_sale ==1 && cartList[i].goods[j].number<= cartList[i].goods[j].goods.number) {
            total += cartList[i].goods[j].goods.price * cartList[i].goods[j].number;
            goods_num += cartList[i].goods[j].number;
            this.goodsLength = goods_num
          }
        }
      }
      var result = ( parseInt( total * 100 ) / 100 ).toFixed(2); // 保留2位小数且不四色五入
      this.total = result
    },
    chooseShopSelectDefault(index){ // 店铺取消全选
      let cartList = this.cartList;
      this.shopActive = index
      cartList[index].isShop = false
      for (let i = 0; i < cartList[index].goods.length; i++) {
        cartList[index].goods[i].selected = false
      }
      this.cartList = cartList
      // console.log('cartList',this.cartList)
      this.goodsLength = ''
      this.total = 0
    },
    chooseShopSelect(index) {  // 店铺选中
      // console.log(index)
      var currIndex = index
      this.shopActive = index
      let cartList = this.cartList;
      cartList.map((item, k) => {
        if (currIndex == k){
          item.isShop = true
          for (let i = 0; i < cartList[index].goods.length; i++) {
            cartList[index].goods[i].selected = cartList[index].isShop
          }
        } else {
          item.isShop = false;
          var arr = item.goods
          arr.map((gitem,j)=>{
            gitem.selected= false
          })
        }
      })
      // console.log(cartList[index].isShop)
      let goods = cartList[index]; // 当前商品数组
      // console.log(goods)
      this.shopId = cartList[index].id
      this.cartList = cartList
      // console.log(this.cartList)
      this.checkAllCondition()
      this.totalPrice()
    },
    // 商品选中反选
    chooseGoodsSelect(index, gindex) {
      let cartList = this.cartList;
      let count = 0;
      let goodsList = cartList[index].goods; // 当前店铺下商品列表
      let goods = goodsList[gindex]; // 当前商品数组
      // console.log(goods)
      this.selectGoodsCurr = goods
      if (goods.selected) {
        cartList[index].goods[gindex].selected = false; // 改变当前商品状态
        cartList[index].isShop = false; // 改变店铺状态
        // console.log('为false','false')
        // console.log('goods.selected', goods.selected)
        this.goodsLength = ''
      } else { // 选中
        // console.log('为true','true')
        cartList[index].goods[gindex].selected = true;
        this.shopId = goods.shop_id
      // 判断别的店铺选中的商品为false
        cartList.map((item,i)=>{
          if (index != i){
            item.isShop = false
            var arr = item.goods
            arr.map((gitem,j)=>{
              gitem.selected= false
            })
          }
        })
        // console.log('goods.selected2', goods.selected)
        // 当店铺选中商品数量与店铺总数相等时, 改变店铺状态
        let shopGoodsNum = cartList[index].goods.length;			// 店铺总个数
        let goodsArray = cartList[index].goods;
        let selectedNum = 0;
        for (var i in goodsArray) {
          if (goodsArray[i].selected) {
            selectedNum++
          }
        }
        // console.log(selectedNum,goodsArray.length)
        if (selectedNum == goodsArray.length) {
          cartList.map((item,i)=>{
            if (index==i){
              cartList[i].isShop = true
            } else {
              item.isShop = false
              var arr = item.goods
              arr.map((gitem,j)=>{
                gitem.selected= false
              })
            }
          })
          this.shopActive = index
        } else {
          // console.log('01')
          cartList[index].isShop = false
          this.shopActive = -1
        }
      }
      this.cartList = cartList
      // console.log( this.cartList)
      this.checkAllCondition()
      this.totalPrice()
    },
    // 全选条件 店铺全选  反之
    checkAllCondition() {
      let isCheckAll = this.isCheckAll;
      let cartList = this.cartList;					// 购物车列表数据
      let isCheckAllNum = 0;
      for (let i = 0; i < cartList.length; i++) {
        if (cartList[i].isShop == true) {
          isCheckAllNum++
        }
      }
      if (isCheckAllNum == cartList.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      this.totalPrice()
    },
    // 多商户点击全选
    chooseCheckAll() {
      let cartList = this.cartList;
      let isCheckAll = this.isCheckAll;
      if(isCheckAll) {
        this.isCheckAll = false
      } else {
        this.isCheckAll = true
      }
      for(let i=0; i<cartList.length; i++) {
        cartList[i].isShop = this.isCheckAll;
        for(let j=0; j<cartList[i].goods.length; j++) {
          cartList[i].goods[j].selected = this.isCheckAll
        }
      }
      this.totalPrice()
    },
    checkGroup(index){ // 控制某个商户全选
      console.log(index)
      var arr = this.cartList
      var selectIds = this.selectIds
      var index = index
      // var item = item
      if (arr[index].checked_all == 0){
        arr[index].checked_all = 1
      } else {
        arr[index].checked_all = 0
      }
      var goodsList = arr[index].goodsList
      // console.log(arr[index].checked_all)
      if (arr[index].checked_all==1){
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].isChecked = 1
          // selectIds.push(goodsList[i].goodsId)
        }
        // console.log(111)
      } else { // 不是选中状态
        // console.log('不是选中状态')
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].isChecked = 0
        }
        //  selectIds = []
      }
      this.selectIds = selectIds
      // console.log('ids',this.selectIds)
      this.cartList = arr
    },
    //点击单个item事件
    clickItem(gindex,fndex) {
      // console.log('商品index',gindex)
      // console.log('商品父级index',fndex)
      var fndex = fndex // 商品父级index
      var gindex = gindex // 商品index
      var arr = this.cartList
      // console.log('点击选中值',arr[fndex].goodsList[gindex].isChecked)
      var goodList = arr[fndex].goodsList
      var currArr = []
      if (arr[fndex].goodsList[gindex].isChecked == false){
        arr[fndex].goodsList[gindex].isChecked = true
      } else {
        arr[fndex].goodsList[gindex].isChecked = false
      }
      // console.log(goodList)
      this.cartList = arr

    },
    cartLess(item,parentId){ // 减
      var item = item
      // console.log(item)
      var id = item.id
      item.number = item.number - 1
      var parentId = parentId
      var data = {
        number: item.number
      }
      // console.log(item.number)
      var that = this
      upDataCart(id,data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data)
          // that.getList()
          // console.log(item.number)
          var list = that.cartList
          if (item.number == 0 ){ // 为了处理最后一个要清除掉这个对象
            // console.log('==1')
            for (let i=0;i<list.length; i++){
              const goodsArr = list[i].goods
              if (goodsArr.length ==1){ // 判断父级只剩下一个删除父级标题
                if (list[i].id == parentId){
                  list.splice(i,1)
                }

              } else {
                for (let j=0; j<goodsArr.length;j++){
                  if (item.id == goodsArr[j].id){
                    goodsArr.splice(j,1)
                  }
                }
              }


            }
          } else {
            // console.log('!=1')
          }
          this.cartList = list
          this.totalPrice()
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    cartAdd(item){ // 加
      console.log(item)
      var arr = this.cartList;
      var id = item.id
      if (item.number<item.goods.number){
        item.number = item.number + 1
        var data = {
          number: item.number
        }
        var that = this
        upDataCart(id,data).then(res => {
          if(res.code == 200)
          {
            // console.log('res',res.data)
            that.addGetList(id)
          }
          else
          {
            this.$toast(res.message)
          }
        })
      } else {
        console.log('不能加')
      }
      console.log(this.cartList)
    },
    addGetList(id){
      var id = id
      var that = this
      let cartbox = []
      getCartList().then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)

          res.data.map(function(value,index, item){
            // console.log(value)
            cartbox[index] = {
              shop_name: value[0].shop.name,
              isShop: false,
              id: value[0].shop_id,
              goods: value
            }
          })
          for (let i=0;i<cartbox.length; i++){
            var goodsArr =cartbox[i].goods
            for (let j=0; j<goodsArr.length;j++){
              if (id == goodsArr[j].id){
                that.cartList[i].goods[j].number = goodsArr[j].number
              }
            }
          }
          // console.log(cartbox.length)
          this.totalPrice()
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    cartAddNo(item){ // 最后一个商品不能再加了
      console.log('超过商品库存')
    },
    //步进器值发生改变
    stepperChange(good,id) { // 加减
      this.isCheckAll = false
      this.total = 0
      console.log('goods',good)
      console.log(id)
      var id = good.id
      var goods = good
      var num = 0
      // console.log(typeof goods.number)
      // if(goods.number == 0){
      //   num = 1
      // } else {
      //   num = goods.number
      // }
      var data = {
        number:  num = goods.number
      }
      var that = this
      upDataCart(id,data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          that.getList()
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    //左滑删除商品
    deleteButton(item) {
      console.log(item)
      const {goodsId} = item
      // deleteGoods({goodsId: goodsId}).then(resp => {
      //   this.renderData(resp)
      // })
    },
    // 批量选中商品删除
    chooseGoodsDelete() {
      Dialog.confirm({
        title: '提示',
        message: "确认将这" + 1 + "个宝贝删除?",
        confirmButtonText:'删除',
        cancelButtonColor:'我再想想'
      })
        .then(() => {
          // on confirm
          this.adminShow = false
        })
        .catch(() => {
          // on cancel
        });
    },
    onSubmit() {
      this.$toast.success('功能暂未实现！')
    },
  }
  // components: {Tips}
}
</script>

<style lang="scss" scoped>
.card-box .image1 {
  width: 60px;
  height: 60px;display: block;margin-right: 0;
}
.mch-list-box{
  margin: 0 23px;
}
.row-data {
  height: 60px;
  line-height: 60px;
  width: 88px;
  text-align: center;
  //background: #f7f7f7;
  font-size: 24px;
  font-weight: 500;
  color: #2C2C2C;
  border-top: 2px solid #CDCDCD;border-bottom: 2px solid #CDCDCD;
}
.cart-less{
  width: 50px;
  height: 60px;
  line-height: 60px;
  background: #FFFFFF;
  border: 2px solid #CDCDCD;
  border-radius: 10px 0px 0px 10px;font-size: 40px;
 text-align: center;
  font-weight: 500;
  color: #2C2C2C;
}
.cart-less-no{
  width: 50px;
  height: 60px;
  line-height: 60px;
  background: #FFFFFF;
  border: 2px solid #CDCDCD;
  border-radius: 10px 0px 0px 10px;font-size: 40px;
  color: #cccccc;font-weight: 500;text-align: center;
}
.cart-add-no{
  height: 60px;
  line-height: 60px;
  background: #FFFFFF;
  border: 2px solid #CDCDCD;width: 50px;font-size: 40px;
  border-radius: 0px 10px 10px 0px;text-align: center;color: #cccccc;font-weight: bold;
}
.cart-add-number{
  width: 50px;
  height: 60px;
  line-height: 60px;
  background: #FFFFFF;
  border: 2px solid #CDCDCD;
  border-radius: 0px 10px 10px 0px;text-align: center;color: #000;font-weight: bold;font-size: 40px;
}
.null-box2{
  height: 320px;
}
.empty-tips{
  padding-top: 250px;text-align: center;
  .go-goods{
    padding: 0.13333rem 0.53333rem;
    background: #fdd80d;
    border-radius: 0.66667rem;
    margin: 20px auto;width: 100px;
  }
}
.self-support-box{

  .goods-list{
    padding: 0 20px;background: #ffffff;
    .card-box{
      margin-left: 20px;
    }
  }
}
.good-price{
  color: #F23926;
}
.btn-clear{
  padding: 10px 20px 20px;text-align: right;color: #F23926;
}
.goods-settle-accounts{
  background: #ffffff;
  position: fixed;bottom:0;left: 0;width: 100%;padding: 40px 0;border-bottom: 1px solid #f1f1f1;
  img{
    height: 48px;width: 48px;display: inline-block;margin-right: 20px;margin-left: 20px;
  }
  .goods-count-btn{
    padding: 20px 0;background: #F23926;border-radius: 50px;margin: 0 30px;font-size: 30px;
    font-weight: 500;
    color: #FFFFFF;width: 180px;text-align: center;
  }
  .goods-delete{
    padding: 10px 40px;background: rgb(253, 13, 49);border-radius: 50px;margin: 0 30px;color: #ffffff;
  }
}
.mch-list-box{
  .mch-header{
    padding: 20px 0 20px;text-align: left;font-size: 26px;
    font-weight: bold;
    color: #000000;
    .cart-checkbox{
      height:auto;width: 36px;display: inline-block;margin-right: 20px;
    }
  }
  .mch-item{
    margin-bottom: 20px;background: #ffffff;padding: 0 20px;border-radius: 20px;
  }
}
.goods-list{
  .goods-item{
    padding-bottom: 20px;border-bottom: 1PX solid #f2f3f5;padding-top: 20px;
    .cart-checkbox{
      height: 36px;width: 36px;display: inline-block;margin-right: 20px;
    }
  }
}

.van-submit-bar {
  //margin-bottom: .5rem;
  text-align: center;
  font-weight: bold;bottom: 180px;padding-bottom: 0;
}
/deep/.van-swipe-cell__right {
 right: -2px;
}

/*display:flex为弹性布局,设置为1则为填充满*/
/*有的时候修改框架的样式没有效果试着尝试深度修改*/
.van-card {
  background: white;
}

.delete-button {
  height: 100%;
}
.card-box{
  img{
    width: 160px;height: 160px;margin-right: 20px;
  }
  .car-content{
    position: relative;
    width: 430px;height: 170px;
    .car-title{
      text-align: left;width: 100%;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;font-size: 24px;color: #636363;
      -webkit-box-orient: vertical;
    }
    .good-price-box{
      position: absolute;bottom: 0;left: 0;width: 100%;
    }
  }
  .specification-box{
    text-align: left;
    margin: 10px 0;
    .specification-item{
      display: inline-block;background: #f7f8fa;padding: 0 10px;font-size: 18px;color: #323233;
    }
  }

}
</style>
